import { paginationMap } from "./pagination";

export const paginatedProductsMap: GenericObject = {
	...paginationMap,
};
